export function prodByClient(name, idProduto, startDate, endDate) {
  const token = localStorage.getItem("token");
  const reports = {
    simple: () => prodPerClient(token, idProduto, startDate, endDate),
    mt2: () => prodByClientMT2(token, idProduto, startDate, endDate)
  }
  reports[name]()
}

function prodPerClient(token, idProduto, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/report/produtos/client?auth=${token}&idProduto=${idProduto}&startDate=${startDate}&endDate=${endDate}`
  );
}
function prodByClientMT2(token, idProduto, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/report/produtos/client/mt2?auth=${token}&idProduto=${idProduto}&startDate=${startDate}&endDate=${endDate}`
  );
}